export function fiLoadLink(params): HTMLLinkElement {
    const link = document.createElement('link');
    const raf = window.requestAnimationFrame || (<any>window).webkitRequestAnimationFrame;
    Object.assign(link, params);

    function insetLink() {
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    if (raf) raf(insetLink);
    else window.addEventListener('load', insetLink);

    return link;
}
